export const ADMIN = 'admin';
export const PROJECT_ADMIN = 'project_admin';
